import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzXmas80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_XMAS_80: Record<
  Exclude<PageIdWoofzXmas80, PageIdWoofzXmas80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_XMAS_80]: {
    id: PageId.SUBSCRIPTIONS_XMAS_80,
    hasHeader: false,
  },
  [PageId.CHAT_UPSELL_XMAS_80]: {
    id: PageId.CHAT_UPSELL_XMAS_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_XMAS_80]: {
    id: PageId.UPSELL_XMAS_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_XMAS_80]: {
    id: PageId.DOWNLOAD_XMAS_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
